export default (params) => ({
  trigger: {
    name: 'content_blocks.highlighted_product.select_all',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_all',
      params: {
        sub_feature: null,
      },
    },
  },
});
